<template>
  <div class="my-5 col-md-12 text-center">
    <b-icon icon="hdd-network" scale="2"></b-icon>
    <h3 class="mt-4">Trust your developer....something big is on the way!</h3>
    <p>Thank you for your patience.</p>
    <em> <b-icon icon="lock"></b-icon> #This page is under our custody.</em>
    <div class="my-5">
      <b-button @click="$router.push('/')">Go to H  ome</b-button>
    </div>
  </div>
</template>

<script>
export default {
  

}
</script>

<style>

</style>